import { Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'
import type { GlobalBreadcrumbsProps } from './GlobalBreadcrumbs'
import GlobalBreadcrumbs from './GlobalBreadcrumbs'
import PageContainer from './PageContainer'

interface Props {
  title?: ReactNode
  breadcrumbs: GlobalBreadcrumbsProps
  actions?: ReactNode
}

// Recommended MUI Layouting from Toolpad interface style: https://mui.com/toolpad/core/react-page-container/
const PageHeader = ({ breadcrumbs, title, actions }: Props) => {
  return (
    <PageContainer disableBottomGutter sx={{ mb: 1 }}>
      <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
        <GlobalBreadcrumbs path={breadcrumbs.path} current={breadcrumbs.current} />
        {actions}
      </Stack>
      {title && (
        <Typography variant="h4">
          {title}
        </Typography>
      )}
    </PageContainer>
  )
}

export default PageHeader
